import { BigNisButton } from "../BigNisButton";
import { FormModal } from "../../../../lib/ui/controls/FormModal";
export class ConfirmationModal extends FormModal {
    constructor(config, options = null) {
        super(options ?? { size: "small" });
        this.config = config;
    }
    render() {
        super.render();
        this.title.set(this.config.title || "Confirmation");
        this.explanation = c("<p></p>").text(this.config.body).appendTo(this.body);
    }
    getButtons() {
        return [
            ...this.config.options.map(o => new BigNisButton(o.text, o.kind)
                .onClick(() => this.confirm(o.value)))
        ];
    }
    getValueForCancel() {
        return this.config.options.find(o => o.is_cancel)?.value;
    }
}
(function (ConfirmationModal) {
    function simple(title, body, cancel_name, confirm_name) {
        return new ConfirmationModal({
            title: title,
            body: body,
            options: [
                { kind: "neutral", text: cancel_name, value: false, is_cancel: true },
                { kind: "cancel", text: confirm_name, value: true },
            ]
        });
    }
    ConfirmationModal.simple = simple;
})(ConfirmationModal || (ConfirmationModal = {}));
